import { apiClient, unwrap } from '@services/api';
import type {
  Reminder,
  ReminderSettings,
  NotificationTestResults,
  SaveReminderSettingsResponse,
} from '@/types';

export const reminderService = {
  async getReminders(): Promise<Reminder[]> {
    const res = await apiClient.get<Reminder[]>('/reminders');
    return unwrap(res);
  },

  async createReminder(data: {
    title: string;
    type: string;
    date?: string;
    statementDay?: number;
    frequency?: string;
    cardType?: string;
  }): Promise<Reminder> {
    const res = await apiClient.post<{ reminder: Reminder }>('/reminders', data);
    return unwrap(res).reminder;
  },

  async updateReminder(id: string, data: Partial<Reminder>): Promise<Reminder> {
    const res = await apiClient.patch<{ reminder: Reminder }>('/reminders', { id, ...data });
    return unwrap(res).reminder;
  },

  async deleteReminder(id: string): Promise<void> {
    await apiClient.delete(`/reminders/${id}`);
  },

  async bulkDelete(ids: string[]): Promise<void> {
    await apiClient.post('/reminders/bulk-delete', { ids });
  },

  async completeReminder(id: string): Promise<Reminder> {
    const res = await apiClient.post<{ reminder: Reminder }>(`/reminders/${id}/complete`);
    return unwrap(res).reminder;
  },

  async getSettings(): Promise<ReminderSettings> {
    const res = await apiClient.get<ReminderSettings>('/reminders/settings');
    return unwrap(res);
  },

  async saveSettings(data: Partial<ReminderSettings>): Promise<SaveReminderSettingsResponse> {
    const res = await apiClient.post<SaveReminderSettingsResponse>('/reminders/settings', data);
    return unwrap(res);
  },

  async sendTestNotifications(): Promise<{ testResults: NotificationTestResults }> {
    const res = await apiClient.post<{ testResults: NotificationTestResults }>('/reminders/test');
    return unwrap(res);
  },

  async resetCustomSetting(id: string): Promise<Reminder> {
    const res = await apiClient.post<{ reminder: Reminder }>(`/reminders/${id}/reset-custom`);
    return unwrap(res).reminder;
  },
};
